module.exports = __webpack_public_path__ + "img/logo1.da819ff2.png";